import { Component, OnInit } from '@angular/core';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { Region } from 'src/app/shared/models/dtos/region/region';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss'],
})
/**
 * Account Settings Component with tabs :)
 */
export class AccountSettingsComponent implements OnInit {
  availableRegions?: Region[];

  /**
   * @constructor
   */
  constructor(
    private readonly authenticatedUserService: AuthenticatedUserService
  ) {}

  /**
   * Get available regions
   * TODO: once EL-1088 is done, get available langues too
   */
  ngOnInit() {
    // TODO understand if we should subscribe to this change
    this.availableRegions = this.authenticatedUserService.admin?.regions;
  }
}
